import { render, staticRenderFns } from "./dutyuser.vue?vue&type=template&id=5744592e&scoped=true&"
import script from "./dutyuser.vue?vue&type=script&lang=js&"
export * from "./dutyuser.vue?vue&type=script&lang=js&"
import style0 from "./dutyuser.vue?vue&type=style&index=0&id=5744592e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5744592e",
  null
  
)

export default component.exports